module.exports = __webpack_public_path__ + "static/top_right-9582d64283e9440779f5f2729bbf52ce.png";